import { createSignal, createMemo, For } from "solid-js";

import { useAdminContext } from "./AdminContext";

function resultsToScore(results: any, options: any = {}) {
    let score = -1;
    for(const r of results) {
        if(options.verified && r.date === 'null') continue;

        let {exit_code, note} = r;
        note = parseInt(note);
        if(exit_code == 0) {
            score = 100;
            break;
        }
        if(note > score)
            score = note;
    }

    if(score == 100) return '✓';
    if(score > 0) return score;
    
    return '❌'
};

const User = (props: any) => {
    return <a href={props.user.project_url} target="_blank">{props.hideNames ? `Student ${props.index + 1}` : props.user.username}</a>
}

// Function to count solved problems for a user
function countSolvedProblems(user: any, verifiedProblems: any, problems: any) {
    let count = 0;
    
    // Count verified problems
    Object.keys(verifiedProblems).forEach(problemName => {
        if (verifiedProblems[problemName][user.username]) {
            const score = resultsToScore(verifiedProblems[problemName][user.username], {verified: true});
            if (score === '✓') count++;
        }
    });
    
    // Count other problems
    Object.keys(problems).forEach(problemName => {
        if (problems[problemName][user.username]) {
            const score = resultsToScore(problems[problemName][user.username]);
            if (score === '✓') count++;
        }
    });
    
    return count;
}

export default () => {
    
    const [hideNames, setHideNames] = createSignal(true); // Hidden by default
    const [adminStore] = useAdminContext() as any;

    const filtered = createMemo(
        () => {
            const currentYear = new Date().getFullYear();
            const results = adminStore.results;
            const verifiedProblems: any = {};
            const problems: any = {};
            const users = adminStore.users.filter(({username}: any) => results[username]);
            
            Object.keys(results).forEach((username) => {
                results[username].forEach((p: any) => {
                    const problem_name = p.problem_name || p.folder;
                    if(p.verified_problem_name !== "null" && p.deadline.localeCompare(currentYear) >= 0)
                    {
                        if(!verifiedProblems[problem_name]) verifiedProblems[problem_name] = {};
                        verifiedProblems[problem_name][username] = p.results || null;
                    } else {
                        if(!problems[problem_name]) problems[problem_name] = {};
                        problems[problem_name][username] = p.results || null;
                    }
                });
           });

           // Sort users by number of solved problems (ascending)
           const sortedUsers = users.sort((a: any, b: any) => {
               const countA = countSolvedProblems(a, verifiedProblems, problems);
               const countB = countSolvedProblems(b, verifiedProblems, problems);
               return countA - countB; // Ascending order
           });

           console.log({verifiedProblems, problems, users: sortedUsers})
           return {verifiedProblems, problems, users: sortedUsers};
        }
    );

    return <div>
    <div class="mb-3">
        <label class="form-check-label me-3">
            <input 
                type="checkbox" 
                class="form-check-input me-1"
                checked={hideNames()} 
                onChange={(e) => setHideNames(e.target.checked)}
            />
            Hide student names
        </label>
        <small class="text-muted">Students are ordered by number of solved problems (ascending)</small>
    </div>
    
    <h3>Problèmes vérifiés</h3>
    <div class="problems-table-wrapper">
        <table class="table table-bordered table-hove table-sm rotate problems">
        <thead>
            <tr class="rotate">
            <th scope="col" class="student-col" style={{"z-index": 100001}}>Etudiant</th>
            <th scope="col" class="student-col" style={{"z-index": 100000}}>Nb exos résolus</th>{
                Object.keys(filtered().verifiedProblems).sort().map((problem_name, i) => (
                <th scope="col" class="rotate"  style={{"z-index": 99999-i}}><div><span>{problem_name}</span></div></th>
                ))
            }
            </tr>
        </thead>
        <tbody>
            <For each={filtered().users} fallback={<div>Loading...</div>}>
                {(item: any, index) => (
                    <tr>
                        <th scope="row" class={"student-col status-"+item.status}>
                            <User user={item} hideNames={hideNames()} index={index()} />
                        </th>
                        <td class="student-col">
                            {Object.keys(filtered().problems).reduce((count, problemName) => {
                                if (filtered().problems[problemName][item.username]) {
                                    const score = resultsToScore(filtered().problems[problemName][item.username]);
                                    if (score === '✓') count++;
                                }
                                return count;
                            }, 0)}
                        </td>
                        <For each={Object.keys(filtered().verifiedProblems).sort()}>
                            {(problem_name) => (
                                <td>{
        filtered().verifiedProblems[problem_name][item.username] 
     ? resultsToScore(filtered().verifiedProblems[problem_name][item.username], {verified: true}) 
     : ' '}
                                </td>
                            )}
                        </For>
                    </tr>
                )}
            </For>
        </tbody>
        </table>
    </div>

    
    <h3>Autres problèmes</h3>
    <div class="problems-table-wrapper">
        <table class="table table-bordered table-hove table-sm rotate problems">
        <thead>
            <tr class="rotate">
            <th scope="col" class="student-col" style={{"z-index": 100001}}>Etudiant</th>{
                Object.keys(filtered().problems).sort().map((problem_name, i) => (
                <th scope="col" class="rotate"  style={{"z-index": 100000-i}}><div><span>{problem_name}</span></div></th>
                ))
            }
            </tr>
        </thead>
        <tbody>
            <For each={filtered().users} fallback={<div>Loading...</div>}>
                {(item: any, index) => (
                    <tr>
                        <th scope="row" class={"student-col status-"+item.status}>
                            <User user={item} hideNames={hideNames()} index={index()} />
                        </th>
                        <For each={Object.keys(filtered().problems).sort()}>
                            {(problem_name) => (
                                <td>{
        filtered().problems[problem_name][item.username] 
     ? resultsToScore(filtered().problems[problem_name][item.username]) 
     : ' '
     }
                                </td>
                            )}
                        </For>
                    </tr>
                )}
            </For>
        </tbody>
        </table>
    </div>
</div>
}

/*
  <tbody>
    {filtered().users.sort((a,b) => a.username.localeCompare(b.username)).filter(a => a.username != 'bramas' && a.username != 'dufresnee').map(({status, username, results}) => (
                  <tr key={username}>
                    <th scope="row" class={"student-col status-"+status}>{username} <a href={GITLAB_REPO_URL.replace('{namespace}', state.project.namespace.path).replace('{name}', username.replace('.','-'))} target="_blank">r</a></th>
                    {
                      Object.keys(filtered().verifiedProblems).sort().map((problem_name) => (
                        <td>{(filtered().verifiedProblems[problem_name][username] 
                          && parseInt(filtered().verifiedProblems[problem_name][username])) || '0'}</td>
                      ))
                    }
                  </tr>)
    )}
  </tbody>
</table>
</div>
<h3>Autres problèmes</h3>
<div class="problems-table-wrapper">
<table class="table table-bordered table-hove table-sm rotate problems">
  <thead>
    <tr class="rotate">
      <th scope="col" class="student-col" style={{zIndex:100001}}>Etudiant</th>{
        Object.keys(filtered().problems).sort().map((problem_name, i) => (
          <th scope="col" class="rotate" style={{zIndex:100000-i}}><div><span>{problem_name}</span></div></th>
        ))
      }
    </tr>
  </thead>
  <tbody>
    {filtered().users.map(({status, username, results}) => (
                  <tr key={username}>
                    <th scope="row" class={"student-col status-"+status}>{username}</th>
                    {
                      Object.keys(filtered().problems).sort().map((problem_name) => (
                        <td>{filtered().problems[problem_name][username] === undefined
                        ? '' :
                        ( parseInt(filtered().problems[problem_name][username])
                          ?'✓':'❌'
                        )}</td>
                      ))
                    }
                  </tr>)
    )}
  </tbody>
</table>
</div>
</div>
}*/